import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class SidePanelCypressAttribute extends CypressAttribute {
  static buttons = {
    OPEN_PANEL_BUTTON: 'SidePanelCypressAttribute:buttons:OPEN_PANEL_BUTTON',
    CLOSE_PANEL_BUTTON: 'SidePanelCypressAttribute:buttons:CLOSE_PANEL_BUTTON',
    CLOSE_MODAL_BUTTON: 'SidePanelCypressAttribute:buttons:CLOSE_MODAL_BUTTON',
    LOCK_ICON_BUTTON: 'SidePanelCypressAttribute:buttons:LOCK_ICON_BUTTON',
    LOCK_STEP_ICON_BUTTON: 'SidePanelCypressAttribute:buttons:LOCK_STEP_ICON_BUTTON'
  };

  static inputs = {};

  static views = {
    PANEL_CONTENT: 'SidePanelCypressAttribute:views:PANEL_CONTENT'
  };
}
